module.exports = __webpack_public_path__ + "static/zoom-3-626215976ef9546eb0d182b144d2580e.jpg";